// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"Vazirmatn", sans-serif',
  },
});

export default theme;
